
import { Component, AfterViewInit, ChangeDetectorRef} from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { Restaurant } from 'src/interfaces/restaurant.model';

@Component({
    selector: 'app-restaurant-title',
    templateUrl: './menu-restaurant-title.component.html',
    styleUrls: ['./menu-restaurant-title.component.css'],
    standalone: false
})
export class RestaurantTitleComponent implements AfterViewInit {
  constructor(private dataService: DataService, private cdr: ChangeDetectorRef,) {}

  restaurant: Restaurant | null = null;

  ngAfterViewInit() {
    // Получаем изначальную ширину блока после загрузки компонента
    let width = window.innerWidth;
     this.restaurant =this.dataService.restaurant;
    this.cdr.detectChanges(); 
    // console.log('RestaurantTitleComponent | ngAfterViewInit()');
  }


}
